import { Wrapper, Title, InnerWrapper } from './HowItWorks.styles';
import ExternalSiteLink from '../ExternalSiteLink';

export default function HowItWorks() {
  return (
    <Wrapper>
      <Title>How the Federal Used EV Tax Credit Works</Title>
      <InnerWrapper>
        <p>
          To qualify for the federal used EV tax credit, both the buyer and the
          vehicle they’re purchasing need to meet specific qualifications
          established by the federal government and codified in the{' '}
          <span>
            <ExternalSiteLink
              section="How It Works"
              url="https://www.irs.gov/inflation-reduction-act-of-2022"
            >
              Inflation Reduction Act
            </ExternalSiteLink>
          </span>
          . Carvana makes it easy to understand which vehicles may qualify for
          the credit. Just look for the “EV Credit” badge while you search or
          view individual vehicles as you shop.
        </p>
        <p>
          Currently, tax filers must file Form 8936 with the IRS to claim a used
          EV tax credit, which they can then apply to reduce their federal tax
          liability.
        </p>
        <p>
          Coming soon, qualified customers who purchase a qualified vehicle with
          Carvana have the option to apply the value of their tax credit
          directly towards their new ride at the time of purchase, rather than
          waiting to claim the credit at tax time.
        </p>
        <p className="t-body-sm">
          Dealers must register with the IRS to allow qualified customers to
          apply the federal used EV tax credit to the purchase price of the
          vehicle, so not every dealer will offer this alternative way to take
          advantage of this tax credit.
        </p>
      </InnerWrapper>
    </Wrapper>
  );
}
